module.exports = __webpack_public_path__ + "static/media/es_outdoor_hot_permacool.65ed7229.png";